<nav class="navbar navbar-expand-sm navbar-dark header-sgi">
    <a class="navbar-brand" href="javascript:void(0)">
        <img class="logo-sgi"  src="assets/img/logo/sgi-mini.png"/>
    </a>
    <button class="navbar-toggler collapsed" type="button" data-toggle="collapse" data-target="#navbarSiriema" 
      aria-controls="navbarSiriema" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="navbar-collapse collapse" id="navbarSiriema">
      <ul class="navbar-nav mr-auto">
        <li class="nav-item">
          <a class="nav-link" [routerLink]="['/autorizacao/nova']" routerLinkActive="router-link-active">
            Nova Autorização</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" [routerLink]="['/autorizacao/lista']" routerLinkActive="router-link-active">
            Lista de Autorizações</a>
        </li>
      </ul>
      <div class="form-inline my-2 my-md-0"> 
        <button class="btn btn-outline-light" (click)="logout()">Logout</button>
      </div>
    </div>
  </nav>